<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/11NkM1c/tc-custom/9781461751175.jpg?1709183767523" alt="This image is the cover for the book Iron Knights, Stackpole Military History Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Iron Knights, Stackpole Military History Series
      </h1>
      <p class="bookDescription body article font2">
        <p><b>This WWII combat history vividly recounts the exploits of the US 66th Armored Regiment from its initial formation to D-Day and the Race for Berlin.</b></p><p> The U.S. 66th Armored Regiment was the only American heavy tank unit to see combat in World War I. By the time America went to war in Europe a second time, it was on the cutting edge of armored warfare. From its baptism of fire in the mud of the Western Front in 1918 to its triumphant march into Berlin in July 1945, <i>Iron Knights</i> tells the story of this legendary regiment.   </p><p> When the Great War ended, the 66th Armored Regiment served as a laboratory for new ideas and equipment. After training under Gen. George S. Patton, the 66th distinguished itself in numerous battles during World War II, earning six battle streamers for the unit and a Medal of Honor for one of its officers. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gordon A Blaker
      </h2>
      
      <p class="authorDescription body article">Gordon A. Blaker is a retired armor officer with extensive experience in tank units. He holds a master's degree in American history and is an active member of the Company of Military Historians. He lives in Georgia.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      STACKPOLE BOOKS
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8750984c